import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { apiError } from '@/lib/api';
import { loadInterests, setContactInterest, useContactInterests } from '@/lib/interestingContacts';
import './ContactInterest.css';

export function LionIcon({className = ''}) {
  return <img src="/loewenstark-lion.png" alt="" aria-hidden="true" className={`interest-lion-icon ${className}`}/>;
}
export default function ContactInterest({customerId, disabled = false}) {
  const {user} = useAuth() || {};
  const state = useContactInterests(user);
  if (!customerId || !user?.id) return null;
  const active = state.ids.has(customerId), busy = state.pending.has(customerId);
  const label = state.error ? 'Markierungen erneut laden' : active ? 'Interessant-Markierung entfernen' : 'Als interessant markieren und mir zuordnen';
  const toggle = async event => {
    event.preventDefault(); event.stopPropagation();
    if (state.error) {await loadInterests(user,true); return;}
    try {await setContactInterest(user, customerId, !active);}
    catch(error) {toast.error(apiError(error));}
  };
  return <button type="button" data-mobile-plain className={`contact-interest nodrag nopan ${active ? 'is-marked' : ''}`} aria-label={label} title={label}
    aria-pressed={active} aria-busy={busy || undefined} disabled={busy || (!state.ready && !state.error) || (disabled && !active)}
    data-testid={`contact-interest-${customerId}`} onTouchStart={event => event.stopPropagation()} onTouchMove={event => event.stopPropagation()} onTouchEnd={event => event.stopPropagation()} onClick={toggle} onKeyDown={event => event.stopPropagation()}>
    <LionIcon/>
  </button>;
}
export function InterestFrame({customerId, children, disabled = false}) {
  if (!customerId) return children;
  return <div className="interest-frame"><div className="interest-frame-content">{children}</div><ContactInterest customerId={customerId} disabled={disabled}/></div>;
}

